import { getCompanyBankDetailListQueryKey } from "Company/Modules/BankDetail/Api/Query/useCompanyBankDetailListQuery";
import {
	type CompanyBankDetailCreateDto,
	postCompanyCompanyIdBankDetail,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const bankDetailMutationsResource = Resources.base.bankDetail.mutations;

export const useCreateCompanyBankDetailMutation = (companyId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: CompanyBankDetailCreateDto) =>
			postCompanyCompanyIdBankDetail(data, companyId),
		),
		onError: (error) => {
			console.error(
				`${t(bankDetailMutationsResource.createBankDetailError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(bankDetailMutationsResource.createBankDetailSuccess));
			queryClient.invalidateQueries({
				queryKey: getCompanyBankDetailListQueryKey(companyId),
			});
		},
	});
};
